import dawascoLogo from "../assets/DAWASCO.png";
import udsmLogo from "../assets/udsm.jpeg";
import azaniaLogo from "../assets/azania.png";
import nssfLogo from "../assets/NSSSF.png";
import serengetiLogo from "../assets/SERENGETI.png";
import stanbicLogo from "../assets/STANBIC.png";
import traLogo from "../assets/TRA.png";
import vodacomLogo from "../assets/VODACOM.png";
import tanescoLogo from "../assets/tanesco.png";
import aghakhanLogo from "../assets/aghakhan.png";
import baobabLogo from "../assets/baobab.png";
import barrickLogo from "../assets/barrick.png";
import botLogo from "../assets/BOT.png";
import ccLogo from "../assets/cc.png";
import ccmLogo from "../assets/ccm.png";
import crdbLogo from "../assets/crdb.png";
import fezaLogo from "../assets/feza.png";
import ivoLogo from "../assets/ivo.png";
import nmbLogo from "../assets/NMB.jpg";
import kcbLogo from "../assets/kcb.png";
import mazingiraLogo from "../assets/mazingira.png";
import mboniLogo from "../assets/mboni.png";
import mkwawaLogo from "../assets/mkwawa.png";
import muhasLogo from "../assets/muhas.png";
import rocLogo from "../assets/ROC.png";
import scLogo from "../assets/simba cement.png";
import slLogo from "../assets/skill link.png";
import tsLogo from "../assets/tanzania specialist.png";
import unicefLogo from "../assets/unicef.png";
import uvccmLogo from "../assets/uvccm.png";
import zimamotoLogo from "../assets/zimamoto.png";
import fcrLogo from "../assets/fcr.png";
import skylinkLogo from "../assets/skylink.png";

const partners = [
  {
    id: "tra",
    name: "TRA",
    logo: traLogo,
  },
  {
    id: "nssf",
    name: "NSSF",
    logo: nssfLogo,
  },
  {
    id: "fcr",
    name: "FIRST",
    logo: fcrLogo,
  },
  {
    id: "skylink",
    name: "SKY LINK",
    logo: skylinkLogo,
  },
  {
    id: "dawasco",
    name: "DAWASCO",
    logo: dawascoLogo,
  },
  {
    id: "stanbic",
    name: "Stanbic Bank",
    logo: stanbicLogo,
  },
  {
    id: "vodacom",
    name: "Vodacom",
    logo: vodacomLogo,
  },
  {
    id: "serengeti",
    name: "Serengeti",
    logo: serengetiLogo,
  },
  {
    id: "udsm",
    name: "University of Dar es Salaam",
    logo: udsmLogo,
  },
  {
    id: "azania",
    name: "Azania",
    logo: azaniaLogo,
  },
  {
    id: "tanesco",
    name: "Tanesco",
    logo: tanescoLogo,
  },
  {
    id: "aghakhan",
    name: "Agha Khan",
    logo: aghakhanLogo,
  },
  {
    id: "baobab",
    name: "Baobab",
    logo: baobabLogo,
  },
  {
    id: "barrick",
    name: "Barrick",
    logo: barrickLogo,
  },
  {
    id: "bot",
    name: "BOT",
    logo: botLogo,
  },
  {
    id: "cc",
    name: "CC",
    logo: ccLogo,
  },
  {
    id: "ccm",
    name: "CCM",
    logo: ccmLogo,
  },
  {
    id: "crdb",
    name: "CRDB",
    logo: crdbLogo,
  },
  {
    id: "feza",
    name: "Feza",
    logo: fezaLogo,
  },
  {
    id: "ivo",
    name: "IVO",
    logo: ivoLogo,
  },
  {
    id: "kcb",
    name: "KCB",
    logo: kcbLogo,
  },
  {
    id: "mazingira",
    name: "Mazingira",
    logo: mazingiraLogo,
  },
  {
    id: "mboni",
    name: "Mboni",
    logo: mboniLogo,
  },
  {
    id: "mkwawa",
    name: "Mkwawa",
    logo: mkwawaLogo,
  },
  {
    id: "muhas",
    name: "Muhas",
    logo: muhasLogo,
  },
  {
    id: "roc",
    name: "ROC",
    logo: rocLogo,
  },
  {
    id: "sc",
    name: "Simba Cement",
    logo: scLogo,
  },
  {
    id: "sl",
    name: "Skill Link",
    logo: slLogo,
  },
  {
    id: "ts",
    name: "Tanzania Specialist",
    logo: tsLogo,
  },
  {
    id: "unicef",
    name: "UNICEF",
    logo: unicefLogo,
  },
  {
    id: "uvccm",
    name: "UVCCM",
    logo: uvccmLogo,
  },
  {
    id: "zimamoto",
    name: "Zimamoto",
    logo: zimamotoLogo,
  },
  {
    id: "nmb",
    name: "NMB",
    logo: nmbLogo,
  },
];

export default function Partners() {
  return (
    <section
      className="MainBodySection home-partners-section"
      aria-labelledby="home-partners-title"
    >
      <div className="container">
        <div className="home-partners-head" data-aos="fade-up">
          <p className="home-banner-kicker">Loyal Customers</p>
          <h2 id="home-partners-title" className="home-service-title font-bold">
            Brands That Trust Our Craft
          </h2>
        </div>

        <div
          className="home-partners-marquee"
          aria-label="Partner logos"
          data-aos="fade-up"
        >
          <div className="home-partners-track">
            {[0, 1].map((groupIndex) => (
              <div
                className="home-partners-group"
                key={groupIndex}
                aria-hidden={groupIndex === 1}
              >
                {partners.map((partner) => (
                  <div className="home-partner-logo-card" key={partner.id}>
                    <img
                      src={partner.logo}
                      alt={groupIndex === 0 ? `${partner.name} logo` : ""}
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
